import {isDevMode}                   from '@angular/core';
import {AuthGuard}                   from '@angular/fire/auth-guard';
import {Routes}                      from '@angular/router';
import {AuthEntryComponent}          from './lib/logr-auth/comps/auth-entry/auth-entry.component';
import {AuthUnlockComponent}         from './lib/logr-auth/comps/auth-unlock/auth-unlock.component';
import {authCryptoGuard}             from './lib/logr-auth/utils/auth-crypto.guard';
import {redirectUnauthorizedToLogin} from './lib/logr-auth/utils/logr-auth.types';
import {SysComponent}                from './sys/sys.component';
import {ViewDaysComponent} from './sys/view-days/view-days.component';
import {ViewHomeComponent}           from './sys/view-home/view-home.component';

export const routes: Routes = [
	{
		path     : 'login',
		component: AuthEntryComponent,
		children : []
	},
	{
		path     : 'unlock',
		component: AuthUnlockComponent,
		children : []
	},
	{
		pathMatch : 'full',
		path      : '',
		redirectTo: 'home'
	},
	{
		path       : '',
		component  : SysComponent,
		data       : {
			authGuardPipe: redirectUnauthorizedToLogin
		},
		canActivate: [
			AuthGuard,
			...isDevMode() ? [] : [authCryptoGuard]
			// authCryptoGuard
		],
		children   : [
			{
				path     : 'home',
				component: ViewHomeComponent,
				title    : 'Home',
				children : []
			},
			{
				path     : 'days',
				component: ViewDaysComponent,
				title    : 'Days',
				children : []
			}
		]
	}
]
